export default __webpack_public_path__ + "static/media/hht1_ep18_timeline_q04_a.5e1f3c8b.png";